import {restClient} from '@polygon.io/client-js';

class PolygonAPI {
    static readonly polygonClient = restClient("Wze8EHYJoXXguB3egyiGe2rx4N_Udaz1");
}

export default PolygonAPI;